import {Card, Spinner} from 'react-bootstrap'
import Chart from 'react-apexcharts'
import {ApexOptions} from 'apexcharts'

interface Props {
  totalEnrolled: number
  cancellations: number
  neverStarted: number
  loading: boolean
}

export const NetGrowthWaterfallChart = ({totalEnrolled, cancellations, neverStarted, loading}: Props) => {
  const netGrowth = totalEnrolled - cancellations - neverStarted

  const series = [{
    data: [
      {x: 'New Enrollments', y: totalEnrolled, fillColor: '#3699ff'},
      {x: 'Cancellations',   y: -cancellations, fillColor: '#f64e60'},
      {x: 'Never Started',   y: -neverStarted,  fillColor: '#ffa800'},
      {x: 'Net Growth',      y: netGrowth,       fillColor: netGrowth >= 0 ? '#1bc5bd' : '#f64e60'},
    ],
  }]

  const options: ApexOptions = {
    chart: {
      type: 'bar',
      height: 240,
      toolbar: {show: false},
    },
    plotOptions: {
      bar: {
        horizontal: true,
        columnWidth: '50%',
        borderRadius: 4,
        distributed: true,
      },
    },
    dataLabels: {
      enabled: true,
      formatter: (val: number) => val > 0 ? `+${val.toLocaleString()}` : val.toLocaleString(),
      style: {fontSize: '12px', fontWeight: 600, colors: ['#fff']},
    },
    xaxis: {
      type: 'category',
      labels: {style: {fontWeight: 600}},
    },
    yaxis: {
      labels: {formatter: (v: number) => v.toLocaleString()},
    },
    legend: {show: false},
    tooltip: {
      y: {formatter: (v: number) => v > 0 ? `+${v.toLocaleString()}` : v.toLocaleString()},
    },
  }

  return (
    <Card className='card-flush'>
      <Card.Header className='border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>Net Growth Breakdown</span>
          <span className='text-muted fw-semibold fs-7'>
            New enrollments minus cancellations and never started
          </span>
        </h3>
      </Card.Header>
      <Card.Body>
        {loading && (
          <div className='d-flex justify-content-center align-items-center' style={{height: 240}}>
            <Spinner animation='border' />
          </div>
        )}
        {!loading && (
          <Chart options={options} series={series} type='bar' height={240} />
        )}
      </Card.Body>
    </Card>
  )
}
